import classNames from 'classnames';

import ToggleModalButton from 'components/toggle_modal_button';

import menuItem from './menu_item';

type Props = {
    modalId: string;
    dialogType: React.ComponentType<any>;
    dialogProps?: Record<string, any>;
    extraText?: string;
    text?: React.ReactNode;
    ariaLabel?: string;
    className?: string;
    children?: React.ReactNode;
    sibling?: React.ReactNode;
    showUnread?: boolean;
    onClick?: () => void;
    'data-testid'?: string;
}

export const MenuItemToggleModalReduxImpl = ({modalId, dialogType, dialogProps, text, ariaLabel, extraText, children, className, sibling, showUnread, onClick, 'data-testid': dataTestId}: Props) => (
    <>
        <ToggleModalButton
            data-testid={dataTestId}
            ariaLabel={ariaLabel}
            modalId={modalId}
            dialogType={dialogType}
            dialogProps={dialogProps}
            className={classNames({
                'MenuItem__with-help': extraText,
                [`${className}`]: className,
            })}
            showUnread={showUnread}
            onClick={onClick}
        >
            {text && <span className='MenuItem__primary-text'>{text}</span>}
            {extraText && <span className='MenuItem__help-text'>{extraText}</span>}
            {children}
        </ToggleModalButton>
        {sibling}
    </>
);

const MenuItemToggleModalRedux = menuItem(MenuItemToggleModalReduxImpl);
MenuItemToggleModalRedux.displayName = 'MenuItemToggleModalRedux';

export default MenuItemToggleModalRedux;
